var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPartner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .partner-1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .partner-1, .partner-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "partner-1",
    cx: 11.39,
    cy: 26.92,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "partner-1",
    d: "m6.29,38.42c-.81,0-1.45-.75-1.26-1.54.69-2.87,3.28-5,6.36-5s5.67,2.13,6.36,5c.19.79-.45,1.54-1.26,1.54H6.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "partner-1",
    cx: 38.61,
    cy: 26.92,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "partner-1",
    d: "m33.51,38.42c-.81,0-1.45-.75-1.26-1.54.69-2.87,3.28-5,6.36-5s5.67,2.13,6.36,5c.19.79-.45,1.54-1.26,1.54h-10.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "partner-1",
    cx: 25,
    cy: 9.19,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "partner-1",
    d: "m19.9,20.69c-.81,0-1.45-.75-1.26-1.54.69-2.87,3.28-5,6.36-5s5.67,2.13,6.36,5c.19.79-.45,1.54-1.26,1.54h-10.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "partner-1",
    d: "m19.26,8.8c-6.94,2.33-11.99,8.76-12.27,16.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "partner-1",
    d: "m43.01,25.21c-.28-7.65-5.33-14.08-12.27-16.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "partner-1",
    d: "m14.1,40.24c3.03,2.3,6.8,3.67,10.9,3.67s7.87-1.37,10.9-3.67"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "partner-2",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartner);
export default __webpack_public_path__ + "static/media/icon-partner.c52f83bbdceb99c9642802e48f7d9034.svg";
export { ForwardRef as ReactComponent };